// Busca dentro de um filtro com muitos valores (ex.: Marca). Renderizado por snippets/facets.liquid
// logo antes da lista de valores; como custom element, volta a funcionar sozinho quando o
// facets.js re-renderiza a sidebar/drawer por AJAX.
if (!customElements.get('facet-search')) {
  const normalize = (value) =>
    value
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .trim();

  class FacetSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.list = this.nextElementSibling;
      if (!this.input || !this.list) return;
      this.input.addEventListener('input', () => this.filter());
      // Enter não deve submeter o formulário de filtros.
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') event.preventDefault();
      });
    }

    get items() {
      return this.list.querySelectorAll(':scope > li');
    }

    get showMoreButton() {
      // O botão fica fora do <fieldset> da lista: sobe até o contêiner do filtro.
      return this.closest('.parent-display, .mobile-facets__submenu, details')?.querySelector('show-more-button');
    }

    filter() {
      const term = normalize(this.input.value);
      const showMore = this.showMoreButton;

      this.items.forEach((item) => {
        if (!item.hasAttribute('data-facet-search-hidden')) {
          item.setAttribute('data-facet-search-hidden', item.classList.contains('hidden') ? 'true' : 'false');
        }
        if (!term) {
          item.classList.toggle('hidden', item.getAttribute('data-facet-search-hidden') === 'true');
          item.removeAttribute('data-facet-search-hidden');
          return;
        }
        const label = item.querySelector('.facet-checkbox__text-label') || item;
        item.classList.toggle('hidden', !normalize(label.textContent).includes(term));
      });

      if (showMore) showMore.classList.toggle('facet-search--hidden', Boolean(term));
    }
  }

  customElements.define('facet-search', FacetSearch);
}
